import classNames from 'classnames';
import React from 'react';
import styles from './Overlay.scss';

/*
Component which stacks children on top of each other using a CSS grid.
*/

export default function Overlay({ className, children }) {
  return (
    <div className={classNames(className, styles.overlay)}>{children}</div>
  );
}
